module.exports = __webpack_public_path__ + "static/img/service-request.5262fda.svg";